/**
 * sl-1p6i: Centralized HEIC/HEIF decoding via heic-to (WASM, libheif).
 * Single source of truth — all HEIC conversion in the app uses this module.
 */

/** HEIC/HEIF MIME types that browsers (except Safari) cannot decode natively. */
export const HEIC_MIMES = new Set(['image/heic', 'image/heif']);

/** HEIC/HEIF file extensions. */
export const HEIC_EXTS = new Set(['heic', 'heif']);

/** Check if a MIME type is HEIC/HEIF. */
export function isHeicMime(mime: string): boolean {
  return HEIC_MIMES.has(mime);
}

/**
 * Decode a HEIC/HEIF blob to JPEG via heic-to (WASM-based, libheif 1.21.2).
 *
 * Returns a JPEG Blob and a synthetic FileTypeResult for cache compatibility.
 * Uses dynamic import so the ~5MB WASM bundle is only loaded when needed.
 */
export async function heicDecode(
  blob: Blob,
  quality = 0.9
): Promise<{ jpeg: Blob; fileType: { ext: string; mime: string } }> {
  const { heicTo } = await import('heic-to');
  const jpeg = await heicTo({ blob, type: 'image/jpeg', quality });
  return {
    jpeg,
    fileType: { ext: 'jpg', mime: 'image/jpeg' },
  };
}
